import React from 'react';
import { observer, inject } from 'mobx-react';
import LineItemPickerPanel from 'components/LineItemPicker/LineItemPickerPanel';

// "Add labor" / "Add material" on a work order (components/LineItemPicker).
// Callers pass `type`: 'Service' for labor, 'Products (Non-inventory)' for materials.
const AddProductForWorkReportModal = inject('workReportStore')(observer(({ workReportStore, isOpen, onClose, workDetail, type, itemType }) => {
  const kind = type === 'Service' ? 'labour' : 'material';
  return (
    <LineItemPickerPanel
      formType="Work"
      noun="work order"
      record={workDetail || workReportStore.workReport.object}
      type={type}
      itemType={itemType}
      isOpen={isOpen}
      onClose={onClose}
      blankBusy={Boolean(workReportStore.isLoadingBlankMaterialLineItem || workReportStore.isLoadingBlankLabourLineItem)}
      onAddBlank={() => workReportStore.addBlankLineItemForProduct(kind, (workDetail || workReportStore.workReport.object).attributes.id)}
    />
  );
}));

export default AddProductForWorkReportModal;
